import React from 'react';
const SvgDwf = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#1273C5" d="M22 1l7 7h-7V1z" />
      <path fill="#0C5089" d="M3 1v30h26V8h-7V1H3z" />
      <path fill="#FFF" d="M4 2v20h24V8h-6V2H4z" />
      <path opacity={0.2} fill="#1B3F63" d="M29 15l-7-7h7v7z" />
      <g>
        <circle fill="#059DD2" cx={16} cy={12} r={7} />
        <path
          fill="#37B9E5"
          d="M16 5c-.4 0-.8 0-1.1.1-1.9 1-3.1 3-3.1 5.2 0 3.3 2.7 5.9 5.9 5.9 2.3 0 4.2-1.3 5.2-3.1.1-.3.1-.7.1-1.1 0-3.9-3.1-7-7-7z"
        />
        <path
          fill="#FF9B0D"
          d="M22.4 14.9c-.3-3.7-5.9-6.9-10.5-6.5-.2.6-.1.9-.1.9l-1.6-.8 2.4-1.6s-.2.4-.5.9c4.2-.2 10.3 2.5 10.3 7.1z"
        />
        <path
          fill="#FFE44D"
          d="M9.5 14.9c3.2 2 9.2-.6 11.7-4.7-.4-.5-.7-.7-.7-.7l1.6-.8-.1 3-.5-1c-2.4 3.7-8.3 7-12 4.2z"
        />
        <g fill="#EB3434">
          <path d="M13.6 7.9c.4-1.3 1.1-2.3 2-2.9-1.2.6-2 1.6-2.5 2.9h.5zM13.4 8.4H13c-.9 2.9-.2 6.6 1.3 9h-1.1l2.5 1.4V17s-.3.2-.9.3c-1.6-2.5-2.1-6.2-1.4-8.9z" />
        </g>
      </g>
      <g fill="#FFF">
        <path d="M15.5 29l1-3 1 3h1.2l1.3-5h-1l-1 3.5-1-3.5h-1l-1 3.4-1-3.4h-1l1.3 5h1.2zM9 29h2c.4 0 2 0 2-2.5S11.4 24 11 24H9v5zm2-4c.3 0 1 0 1 1.5s-.8 1.5-1 1.5h-1v-3h1zM21 29v-2h2v-1h-2v-1h2v-1h-3v5h1z" />
      </g>
    </svg>
  );
});
export default SvgDwf;
SvgDwf.iconName = 'dwf';
SvgDwf.displayName = 'SvgDwf';
